import Api from './api';

const LicService = {
    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/licitacao/listar',
            params: params
        })
        return response
    },
    numLic: async (params) => {
        return Api({
            method: 'get',
            url: '/licitacao/numlic',
            params: params
        })
    },
    modalidade: async (params) => {
        return Api({
            method: 'get',
            url: '/licitacao/modalidade',
            params: params
        })
    },
    buscarExpo: async (params) => {
        return Api({
            method: 'get',
            url: '/licitacao/buscar-exposicao',
            params: params
        })
    },
    buscarExpoAnt: async (params) => {
        return Api({
            method: 'get',
            url: '/licitacao/buscar-exposicao-anteriores',
            params: params
        })
    },
    buscar: (params) => {
        const response = Api.get(`/licitacao/buscar?${params}`)
        return response
    }
}

export default LicService;